module.exports = "/images/flag-vi.svg?31e9e171e3d53267994f42a4dfef32fa";